export default function PullQuote({ children, attribution }) {
  return (
    <blockquote className="max-w-4xl mx-auto text-center relative py-8">
      <span className="absolute -top-6 left-1/2 -translate-x-1/2 hairline-gold h-px w-16" aria-hidden />
      <p className="font-serif-display italic text-3xl md:text-5xl leading-[1.15] tracking-tighter text-matte">
        &ldquo;{children}&rdquo;
      </p>
      {attribution && (
        <div className="mt-8 eyebrow text-taupe">{attribution}</div>
      )}
    </blockquote>
  );
}
